import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const SimpleUpArrowIcon = createIcon({
  displayName: 'SimpleUpArrow',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M16,14l-4,-4l-4,4"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      ></path>
      <path fill="none" d="M0,0h24v24h-24Z"></path>
    </>
  ),
})

const SimpleUpArrow: FC<IconProps> = (props) => {
  return <CustomIcon as={SimpleUpArrowIcon} {...props} />
}

export default memo(SimpleUpArrow)
